module.exports = __webpack_public_path__ + "static/media/2a.0d570419.jpg";